<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <router-link class="fl-button grey" :to="{ path: '/access_levels/' }"><i class="fa fa-angle-left"></i></router-link>
            <button :disabled="is_save" class="fl-button" type="button" v-on:click="save"><i class="fa fa-save"></i></button>
          </div>
          <h1>Access Level</h1>
          <div class="row">
            <div class="col-xs-6">
              <inputbox id="name" label="Megnevezés" v-bind:errors="errors" name="name" v-model="form.name"></inputbox>
              <inputbox :disabled="!form.erasable" id="alias" label="Alias" regexp_filter="[a-zA-Z_0-9]+" v-bind:errors="errors" name="alias" v-model="form.alias"></inputbox>
              <select2 multi="true" v-bind:errors="errors" label="Csoportok" name="groups" id="groups" :options="groups" v-model="form.group_ids"/>
              <toggle id="barcode_enabled" label="QR kód engedélyezve" v-bind:errors="errors" name="barcode_enabled" v-model="form.barcode_enabled"></toggle>
              <textareabox id="comment" label="Megjegyzés" v-bind:errors="errors" name="comment" v-model="form.comment"></textareabox>
            </div>
            <div style="margin-bottom: 30px;" class="col-xs-12" v-if="form.elements.length > 0">
              <div v-if="item.deleted == undefined" class="row" :class="{'row-disabled': form.params != null && form.params.tesa_room != undefined}" v-for="(item, i) in form.elements">
                <div class="col-xs-2">
                  <comboboxV2 :id="'element_id_'+i" label="Eszköz" v-bind:errors="errors" :name="'element_id_'+i" v-model="item.element_id" :options="elements"></comboboxV2>
                </div>
                <div class="col-xs-2">
                  <comboboxV2 :id="'schedule_group_id_allow_'+i" label="Schedule engedélyezett" v-bind:errors="errors" :name="'schedule_group_id_allow_'+i" v-model="item.schedule_group_id_allow" :options="schedules"></comboboxV2>
                </div>
                <div class="col-xs-2">
                  <comboboxV2 :id="'schedule_group_id_deny_'+i" label="Schedule tiltott" v-bind:errors="errors" :name="'schedule_group_id_deny_'+i" v-model="item.schedule_group_id_deny" :options="schedules"></comboboxV2>
                </div>
                <div class="col-xs-2">
                  <div class="form-group">
                    <div class="form-label">

                    </div>
                  </div>
                  <button @click="removeElement(i)" type="button" class="button small"><i class="fa fa-trash"></i></button>
                </div>
              </div>
            </div>
          </div>
          <div class="row" :class="{'row-disabled': form.params != null && form.params.tesa_room != undefined}">
            <div class="col-xs-2">
              <comboboxV2 id="new_element_id" label="Eszköz" v-bind:errors="errors" name="new_element_id" v-model="new_element.element_id" :options="elements"></comboboxV2>
            </div>
            <div class="col-xs-2">
              <comboboxV2 id="new_schedule_group_id_allow" label="Schedule engedélyezett" v-bind:errors="errors" name="new_schedule_group_id_allow" v-model="new_element.schedule_group_id_allow" :options="schedules"></comboboxV2>
            </div>
            <div class="col-xs-2">
              <comboboxV2 id="new_schedule_group_id_deny" label="Schedule tiltott" v-bind:errors="errors" name="schedule_group_id_deny" v-model="new_element.schedule_group_id_deny" :options="schedules"></comboboxV2>
            </div>
            <div class="col-xs-2">
              <div class="form-group">
                <div class="form-label">

                </div>
              </div>
              <button @click="addElement" type="button" class="button small orange"><i class="fa fa-plus"></i></button>
            </div>
          </div>

          <div class="row" v-show="$route.query.accesslevelID != undefined">
            <div class="col-sm-12">
              <h2>Kártyák</h2>
              <div class="col-sm-2">
                <inputbox id="owner_name" @input="searchCards" label="Kártya tulajdonos" name="owner_name" v-model="search_cards.owner_name"></inputbox>
              </div>
              <div class="col-sm-2">
                <inputbox regexp_filter="[0-9]+" id="card_number" @input="searchCards" label="Kártyaszám" name="card_number" v-model="search_cards.card_number"></inputbox>
              </div>
              <div class="col-sm-2">
                <inputbox regexp_filter="[a-zA-Z0-9]+" maxlength="8" @input="searchCards" id="rfid" label="RFID" name="rfid" v-model="search_cards.rfid"></inputbox>
              </div>
              <div class="col-sm-2">
                <inputbox regexp_filter="[a-zA-Z0-9]+" maxlength="10" @input="searchCards" id="plate_number" label="Rendszám" name="plate_number" v-model="search_cards.plate_number"></inputbox>
              </div>
              <div class="col-sm-2">
                <button class="button with-icon" style="margin-top: 24px" type="button" v-on:click="searchCards"><i class="fa fa-search"></i>Keresés</button>
              </div>

              <div class="col-md-6">
                <div class="table-with-title">
                  <h2>Access Levelhez rendelt kártyák</h2>
                  <table class="list">
                    <thead>
                      <th>Tulajdonos</th>
                      <th>Kártyaszám</th>
                      <th>RFID</th>
                      <th></th>
                    </thead>
                    <tbody>
                      <tr v-for="card in access_level_cards" :key="card.card_number" :style="{ backgroundColor: card.active == '1' ? 'inherit' : '#eee' }" :title="card.active == '0' ? 'Ez a kártya inaktív' : '' ">
                        <td>{{ card.owner_name }}</td>
                        <td>{{ card.card_number }}</td>
                        <td>{{ card.rf_id }}</td>
                        <td class="buttons">
                          <router-link class="small-button" :to="{ path: '/card/edit/', query: { cardID: card.element_id }}"><i class="fa fa-pencil-alt"></i></router-link>
                          <button class="small-button red" @click="removeAccessLevel(card.element_id)" title="Jelenlegi Access Level megvonása a kártyától"><i class="fa fa-minus"></i></button>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <pagination
                    v-if="access_level_cards.length > 0"
                    showcombo="1"
                    compact="1"
                    :limit="pagination_access_level_cards.limit"
                    :amount="pagination_access_level_cards.amount"
                    @pageChanged="getAccessLevelCards"
                    v-model="pagination_access_level_cards.page"/>
                </div>
              </div>

              <div class="col-md-6">
                <div class="table-with-title">
                  <h2>Access Levelhez nem rendelt kártyák</h2>
                  <table class="list">
                    <thead>
                      <th>Tulajdonos</th>
                      <th>Kártyaszám</th>
                      <th>RFID</th>
                      <th></th>
                    </thead>
                    <tbody>
                      <tr v-for="card in non_access_level_cards" :key="card.card_number" :style="{ backgroundColor: card.active == '1' ? 'inherit' : '#eee' }" :title="card.active == '0' ? 'Ez a kártya inaktív' : '' ">
                        <td>{{ card.owner_name }}</td>
                        <td>{{ card.card_number }}</td>
                        <td>{{ card.rf_id }}</td>
                        <td class="buttons">
                          <router-link class="small-button" :to="{ path: '/card/edit/', query: { cardID: card.element_id }}"><i class="fa fa-pencil-alt"></i></router-link>
                          <button class="small-button green" style="backround-color: lime" @click="addAccessLevel(card.element_id)" title="Jelenlegi Access Level kártyához rendelése"><i class="fa fa-plus"></i></button>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <pagination
                    v-if="non_access_level_cards.length > 0"
                    showcombo="1"
                    compact="1"
                    :limit="pagination_non_access_level_cards.limit"
                    :amount="pagination_non_access_level_cards.amount"
                    @pageChanged="getNonAccessLevelCards"
                    v-model="pagination_non_access_level_cards.page"/>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <HTMLFooter></HTMLFooter>
    <ProgressInfo :show="is_save"/>
  </div>
</template>
<script>
import Vue from 'vue';

export default {
  data: function() {
    return {
      form: {
        name: '',
        alias: '',
        group_ids: [],
        barcode_enabled: {
          value: 1,
          selected: false
        },
        comment: '',
        elements: []
      },
      groups: [],
      access_level_cards: [],
      non_access_level_cards: [],
      search_cards: {
        timeout: null,
        card_number: '',
        owner_name: '',
        rfid: '',
        plate_number: '',
      },
      pagination_access_level_cards: {
        page: 1,
        limit: 10,
        amount: 0
      },
      pagination_non_access_level_cards: {
        page: 1,
        limit: 10,
        amount: 0
      },
      new_element: {
        element_id: 0,
        schedule_group_id_allow: 0,
        schedule_group_id_deny: 0,
      },
      elements: [],
      schedules: [{
        value: 0,
        label: '- válassz -'
      }],
      errors: [],
      is_save: false
    }
  },

  mounted: function() {
    this.loadAccessLevelData();
  },

  methods: {
    loadAccessLevelData: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('access_level/edit/' + _this.$root.user.apikey + '/' + (_this.$route.query.accesslevelID != undefined ? _this.$route.query.accesslevelID : 0), {
          success: function(response) {
            _this.form = response.access_level;
            if (_this.form.params != null) {
              _this.form.params = JSON.parse(_this.form.params);
            }
            _this.groups = response.groups;
            _this.elements = response.elements;
            _this.getSchedules();
            if (_this.$route.query.accesslevelID != undefined) {
              _this.getAccessLevelCards();
            }
            _this.getNonAccessLevelCards();
          }
        });
      });
    },

    removeElement: function(index) {
      this.form.elements.map(function(element, i) {
        if (i == index)
          Vue.set(element, 'deleted', 1);
      });
    },

    addElement: function() {
      this.errors = [];

      if (this.new_element.element_id == 0)
        this.errors.push({
          id: 'new_element_id',
          msg: 'Kötelező'
        });

      if (parseInt(this.new_element.schedule_group_id_allow) == 0 && parseInt(this.new_element.schedule_group_id_deny) == 0)
        this.errors.push({
          id: 'new_schedule_group_id_allow',
          msg: 'Engedélyezés vagy tiltás kötelező'
        });

      if (this.errors.length > 0)
        return;

      this.form.elements.push({
        id: 0,
        element_id: this.new_element.element_id,
        schedule_group_id_allow: this.new_element.schedule_group_id_allow,
        schedule_group_id_deny: this.new_element.schedule_group_id_deny
      });

      this.new_element.element_id = 0;
      this.new_element.schedule_group_id_allow = 0;
      this.new_element.schedule_group_id_deny = 0;
    },

    getSchedules: function() {
      var _this = this;
      var data = {
        called_from: 'access_level',
      };

      _this.$root.ajax('schedules/' + _this.$root.user.apikey, {
        method: 'POST',
        data: data,
        success: function(response) {
          response.schedules.map(function(schedule) {
            _this.schedules.push({
              value: schedule.id,
              label: schedule.name
            });
          });
        }
      });
    },

    save: function (event) {
      var _this = this;
      var form = JSON.parse(JSON.stringify(_this.form));
      this.is_save = true;

      if (this.new_element.element_id != 0) {
        this.is_save = false;
        swal('Új eszköz van beállítva, de nincs hozzáadva a listához!');
        return;
      }

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('access_level/save/' + _this.$root.user.apikey, {
          method: 'POST',
          data: form,
          waitForSaveInfo: true,
          success: function(response) {
            _this.is_save = false;

            if (response.errors.length > 0) {
              _this.errors = response.errors;
            } else {
              if (_this.$route.query.accesslevelID == undefined) {
                _this.$router.push({path: '/access_level/edit', query: {'accesslevelID': response.element_id}});
                _this.loadAccessLevelData();
              } else {
                _this.$router.push({path: '/access_levels'});
              }
            }
          }
        });
      });
    },

    searchCards: function(val) {
      if (val.length > 0 && val.length < 3) { return }
      var _this = this;
      clearTimeout(this.search_cards.timeout);
      this.search_cards.timeout = setTimeout(() => {
        _this.pagination_access_level_cards.page = 1;
        _this.pagination_non_access_level_cards.page = 1;
        _this.getAccessLevelCards();
        _this.getNonAccessLevelCards();
      }, 500);
    },

    getAccessLevelCards: function(val) {
      this.search_cards.page = val;
      var _this = this;
      const data = Object.assign({}, _this.search_cards);
      data.access_level_ids = [ _this.$route.query.accesslevelID ];
      data.limit = this.pagination_access_level_cards.limit;
      data.called_from = 'access_level';
      data.active = 2;
      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('cards/' + _this.$root.user.apikey, {
          data,
          method: 'POST',
          success: function(response) {
            _this.access_level_cards = response.cards;
            _this.pagination_access_level_cards.amount = response.amount;
          }
        });
      });
    },
    getNonAccessLevelCards: function(val) {
      this.search_cards.page = val;
      var _this = this;
      const data = Object.assign({}, _this.search_cards);
      data.not_access_level_ids = [ _this.$route.query.accesslevelID ];
      data.limit = this.pagination_non_access_level_cards.limit;
      data.called_from = 'access_level';
      data.active = 2;
      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('cards/' + _this.$root.user.apikey, {
          data,
          method: 'POST',
          success: function(response) {
            _this.non_access_level_cards = response.cards;
            _this.pagination_non_access_level_cards.amount = response.amount;
          }
        });
      });
    },

    addAccessLevel: function(card_element_id) {
      const _this = this;
      const data = {
        access_level_id: _this.$route.query.accesslevelID,
        to_element_id: card_element_id,
      };
      _this.$root.ajax('cards/addaccesslevel/' + _this.$root.user.apikey, {
        data,
        method: 'POST',
        success: function(response) {
          _this.getAccessLevelCards();
          _this.getNonAccessLevelCards();
        }
      });
    },
    removeAccessLevel: function(card_element_id) {
      const _this = this;
      const data = {
        access_level_id: _this.$route.query.accesslevelID,
        to_element_id: card_element_id,
      };
      _this.$root.ajax('cards/removeaccesslevel/' + _this.$root.user.apikey, {
        data,
        method: 'POST',
        success: function(response) {
          _this.getAccessLevelCards();
          _this.getNonAccessLevelCards();
        }
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// access_level.vue?3b18498d